<template>
  <div>
    <html sigplusextliteextension-installed="true" sigwebext-installed="true"></html>
    <v-card :loading="loading" class="mx-auto my-0" max-width="80%" elevation="0" style="justify-items: center;">
      <template #progress>
        <v-progress-linear color="primary" height="5" indeterminate></v-progress-linear>
      </template>

      <v-img v-if="modo === 1 || modo === 3" height="200" :src="image" contain></v-img>

      <!-- Marco alrededor de vueSignature -->
      <div v-if="modo === 2" style="border: 2px dashed #1976D2; padding: 8px; margin-bottom: 8px; max-width: 500px;">
        <vueSignature
          ref="firma"
          :sigOption="option"
          :w="'859px'"
          :h="'220px'"
          :disabled="modo === 1"
        ></vueSignature>
      </div>

      <!-- Mensaje solo para Firmar con Pad -->
      <v-card-text v-if="modo === 1" class="text-center" style="color: #1976D2;">
        📢 Seguir las instrucciones de la Utilidad de Topaz.
      </v-card-text>

      <v-card-text>
        <v-row class="ma-0 pa-0">
          <template v-if="modo === 0">
            <v-col cols="4" class="ma-0 pa-0">
              <v-btn color="green" block text @click="selectModo(1)" :loading="loading">
                Firmar con Pad
              </v-btn>
            </v-col>
            <v-col cols="4" class="ma-0 pa-0">
              <v-btn color="blue" block text @click="selectModo(2)" :loading="loading">
                Firmar Touch / Mouse
              </v-btn>
            </v-col>
            <v-col cols="4" class="ma-0 pa-0">
              <v-btn color="purple" block text @click="selectModo(3)" :loading="loading">
                Cargar Firma PNG
              </v-btn>
            </v-col>
          </template>

          <template v-else>
            <v-col cols="6" class="ma-0 pa-0">
              <v-btn color="red" block text @click="clear">
                Restablecer Firma
              </v-btn>
            </v-col>
            <v-col cols="6" class="ma-0 pa-0">
              <v-btn color="grey darken-1" block text @click="regresar">
                Cambiar Método de Firma
              </v-btn>
            </v-col>
          </template>
        </v-row>
      </v-card-text>

      <!-- Input file oculto para cargar PNG -->
      <input type="file" ref="fileInput" accept="image/png" style="display: none" @change="onFileSelected" />
    </v-card>
  </div>
</template>

<script>
/* global Topaz */
import vueSignature from "vue-signature";

export default {
  components: {
    vueSignature,
  },
  data: () => ({
    height_sign: 220,
    width_sign: 859,
    image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAADIAQMAAAD82yWhAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAA5SURBVHic7cuhAQAADAKg+f/Tu8Fgg06uFkVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRNuUBzQUAydNVqx4AAAAASUVORK5CYII=",
    defaultImage: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAADIAQMAAAD82yWhAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAA5SURBVHic7cuhAQAADAKg+f/Tu8Fgg06uFkVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRNuUBzQUAydNVqx4AAAAASUVORK5CYII=",
    loading: false,
    modo: 0,
    option: {
      penColor: "rgb(0, 0, 0)",
      backgroundColor: "rgba(0, 0, 0, 0)",
    },
  }),
  created() {
    this.start();
  },
  mounted() {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 2000);
  },
  methods: {
    start() {
      try {
        var url = document.documentElement.getAttribute("SigPlusExtLiteWrapperURL");
        var script = document.createElement("script");
        script.onerror = function () {
          alert("Unable to load required SigPlusExtLite extension wrapper.");
        };
        script.src = url;
        document.head.appendChild(script);
      } catch (ex) {
        alert("Unable to load required SigPlusExtLite extension wrapper.");
      }
    },
    selectModo(modo) {
      this.modo = modo;
      if (modo === 1) {
        this.StartSign();
      } else if (modo === 3) {
        // Abrir selector de archivo
        this.$refs.fileInput.click();
      }
    },
    async StartSign() {
      var isInstalled = document.documentElement.getAttribute("SigPlusExtLiteExtension-installed");
      if (!isInstalled) {
        alert("SigPlusExtLite extension is not installed or disabled.");
        return;
      }
      try {
        let sign = Topaz.SignatureCaptureWindow.Sign;
        sign.SetImageDetails(0, this.width_sign, this.height_sign, true, false, 0.0);
        sign.SetPenDetails("Black", 2);
        sign.SetMinSigPoints(25);
        await sign.StartSign(false, 1, 0, "");

        let lastError = await Topaz.Global.GetLastError();
        if (lastError) {
          alert("SigPlusExtLite Error: " + lastError);
        } else if (await sign.IsSigned()) {
          let imgData = await sign.GetSignatureImage();
          this.image = "data:image/png;base64," + imgData;
        }
      } catch (ex) {
        console.log(ex);
      }
    },
    onFileSelected(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = e => {
          this.image = e.target.result;
          this.modo = 3; // Establecer modo archivo
        };
        reader.readAsDataURL(file);
      }
    },
    isEmpty() {
      return this.modo === 1
        ? this.image === this.defaultImage
        : this.modo === 2 && this.$refs.firma.isEmpty();
    },
    clear() {
      if (this.modo === 1 || this.modo === 3) {
        this.image = this.defaultImage;
        if (this.modo === 3) {
          this.modo = 0; // Volver al selector si es modo PNG
        }
      } else if (this.modo === 2) {
        this.$refs.firma.clear();
      }
    },
    regresar() {
      this.clear();
      this.modo = 0;
    },
    save() {
      return this.modo === 1 || this.modo === 3 ? this.image : this.$refs.firma.save();
    },
  },
};
</script>
